import close from "../assets/close.png";
import { useProductos } from "../hooks/useProductos";
import { useAuth } from "../hooks/useAuth";
import deleteIcon from "../assets/delete.png";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { routes } from "../helpers/Routes";
import Drawer from '@mui/material/Drawer';
const CarritoCompras = ({ setOpenCart, openCart }) => {
    const { cart, getCart, removeCart } = useProductos();
    const [pagar, setPagar] = useState(false);
    const navigate = useNavigate();

    const { usuario } = useAuth();
    const goToCheckout = () => {
        setPagar(true);
    }

    useEffect(() => {
        getCart(usuario?.id_usuario);
    }, [])

    useEffect(() => {
        if (pagar) {
            navigate(routes.checkout);
        }
    }, [pagar])



    return (
        <div className={""}>
            <Drawer open={openCart} onClose={() => setOpenCart(false)}   anchor={"right"}>
            <div style={{ width: "100%", overflow: "auto", padding: "10px" }}>
                {cart?.length <= 0 ? <p style={{marginTop: "30px", marginBottom: "30px"}}>No hay productos para mostrar</p> : ""}
                {cart?.map((producto, idx) => {
                    const miniatura = typeof producto?.img === "string" ? JSON.parse(producto?.img) : producto?.img;
                    return (
                        <div key={idx} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", justifyContent: "center", marginBottom: 40 }}>
                            <img src={miniatura?.find(img => img.isPrimary == "true" || true)?.url?.secure_url || miniatura[0]?.url?.secure_url} width={150} />
                            <p>{producto?.nombre}</p>
                            
                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <p>{producto?.precio}</p>
                                <p>Cantidad: {producto?.cantidad}</p>
                                <p>Color: {producto?.color}</p>
                                <button onClick={() => removeCart(producto?.id, usuario?.id_usuario)} style={{ background: "white", color: "black", paddingTop: 3, paddingBottom: 3, paddingLeft: 5, paddingRight: 5 }}>
                                    <img src={deleteIcon} width={20} style={{ filter: "invert(1)" }} />
                                </button>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div>
                <button onClick={goToCheckout} style={{ background: "white", color: "black", width: "100%" }}>Ir a pagar</button>
            </div>
            </Drawer>
        </div>
    );
}

export default CarritoCompras;


